/**
 * Display only: remove decimal padding without rounding or mutating API values.
 * Keep meaningful fractional digits, including decimal strings beyond JS precision.
 * Do not use this formatter for identifiers, raw medical results or input values.
 */
export function formatNumberCompact(value) {
    if (value === null || value === undefined) return ''
    const raw = String(value)
    const match = raw.trim().match(/^([+-]?)(\d+)(?:[.,](\d+))?(\s*%)?$/)
    if (!match) return raw
    const integer = match[2].replace(/^0+(?=\d)/, '')
    const fraction = (match[3] || '').replace(/0+$/, '')
    const sign = integer === '0' && !fraction ? '' : match[1]
    return sign + integer + (fraction ? ',' + fraction : '') + (match[4] ? '%' : '')
}
